export default __webpack_public_path__ + "static/media/productos.bd6f938c.png";